import { Form, Input, ModalProps, FormProps, Modal, InputNumber } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'

type CreateGradeLevelProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateGradeLevel: React.FC<CreateGradeLevelProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {

    return (
      formProps?.onFinish &&
      formProps?.onFinish({
        ...values,
        created_by: user?.id
      })
    )

  }
  return (
    <Modal {...modalProps} title="Create Grade Level">
      <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('grade_levels', 'create', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        <Form.Item
          label="Grade Level "
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
